// extracted by mini-css-extract-plugin
export default {"header":"style_header__VEO-o","title":"style_title__bpONj"};